export enum AsciiFileCurrencyOptionEnum {
    EUR = 'EUR',
    FRF = 'FRF'
}

export const asciiFileCurrencyOptionsList: string[] = ['EUR', 'FRF'];